import { lazy, Suspense } from "react";

import { LoadingIndicatorFullPage } from "../../../cc-ui/components";

const ProspectDetailsLazy = lazy(() =>
  import("./ProspectDetails").then((module) => ({ default: module.ProspectDetails })),
);

export const ProspectDetailsAsync = () => (
  <Suspense fallback={<LoadingIndicatorFullPage open />}>
    <ProspectDetailsLazy />
  </Suspense>
);
